<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">ACKNOWLEDGMENTS</span></span></p>
<p class="TNI">To Monique, Alex, and the team at St. Martin’s Press for the magnitude of what you do, and to my agent, Laura Bradford, who never gives up hope that I will learn American spelling. To my fabulous Street Team, Sarah’s Sassy Readers, for all your enthusiasm and support, and to Danielle Gorman for keeping me organized. To Danielle Barclay and Mandy Lawler for your boundless energy and creative ideas. And, finally, to my own little tribe for their patience, love, support and blueberry and cucumber kebabs.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?0a39b3ff